import { Component, OnInit, Output, EventEmitter, HostListener, input } from '@angular/core';
import { ToastService } from '../../../services/toast.service';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-notification-card',
    templateUrl: './notification-card.component.html',
    styles: [],
    imports: [CommonModule, MatIcon]
})
export class NotificationCardComponent implements OnInit {
    readonly notificationInfo = input<any>();
    @Output() selectedChanged = new EventEmitter<boolean>();
    selected = false;
    isMobileWidth: boolean;
    positionTop: any;

    constructor(public toastService: ToastService) {}

    remove(index: number) {
        this.toastService.remove(index);
    }

    ngOnInit(): void {
        this.getWidthOfScreenSize();
    }

    ngAfterViewInit() {
        this.getWidthOfScreenSize();
    }

    @HostListener('window:resize')
    getWidthOfScreenSize() {
        let priceCard: any;
        this.toastService.toasts().forEach((toast) => {
            priceCard = toast.priceCard;
        });
        const screenWidth = window.innerWidth;
        if (screenWidth < 1280) {
            this.isMobileWidth = true;
        } else {
            this.isMobileWidth = false;
        }

        if (this.isMobileWidth) {
            this.positionTop = '60px';
        }
        if (!this.isMobileWidth && priceCard) {
            this.positionTop = '310px';
        }
        if (!this.isMobileWidth && !priceCard) {
            this.positionTop = '80px';
        }
    }

    selectNotification() {
        this.selectedChanged.emit(!this.selected);
    }
}
